import state from './noteState';
import mutations from './noteMutations';
import getters from './noteGetters';
import actions from './noteActions';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
